export const RECOMMENDATIONS = {
emotional: {
  critical: [
    [
      "Practice Guided Breathing Exercise on echoBuddy Daily",
      "Listen to echo Healing Soundscapes Every Night",
      "Take a Smile Break to Reset Your Mood"
    ],
    [
      "Log Your Mood on echoBuddy Every Morning",
      "Practice the 5-4-3-2-1 Grounding Technique",
      "Listen to echo Soundscapes for Emotional Calm"
    ],
    [
      "Practice Progressive Muscle Relaxation Daily",
      "Do a Guided Breathing Exercise Twice a Day",
      "Take a Gratitude Moment Every Evening"
    ],
    [
      "Write in Your Journal to Release Emotions",
      "Listen to echo Healing Soundscapes Each Night",
      "Practice a Guided Visualisation Soundscape"
    ],
    [
      "Anchor Yourself with a Daily Gratitude Moment",
      "Practice Guided Breathing on echoBuddy",
      "Join echoBuddy Daily Yoga Session"
    ]
  ],

  atRisk: [
    [
      "Check In on echoBuddy Every Day",
      "Write in Your Journal for Emotional Clarity",
      "Repeat 3 Gratitude Affirmations Each Morning"
    ],
    [
      "Attend an echoBuddy Daily Yoga Session",
      "Set and Protect Healthy Digital Boundaries",
      "Listen to echo Soundscapes for an Emotional Reset"
    ],
    [
      "Practice Box Breathing Twice Every Day",
      "Listen to echo Healing Soundscapes at Night",
      "Take a Desk Stretch Break to Release Tension"
    ],
    [
      "Identify and Name Your Emotional Triggers",
      "Meditate with echo Soundscapes Before Starting Work",
      "Reflect on Self-Compassion Every Sunday"
    ],
    [
      "Practice Positive Self-Talk Every Morning",
      "Do a Smile Break Activity on echoBuddy",
      "Practice Guided Breathing for Emotional Balance"
    ]
  ],

  developing: [
    [
      "Complete the echoBuddy Emotional Wellness Assessment",
      "Follow Personalised Recommendations on echoBuddy",
      "Play a Calming echo Soundscape While You Work"
    ],
    [
      "Practice an Empathy-Building Exercise Daily",
      "Join echoBuddy Daily Yoga Session",
      "Take a 5-Minute Mindful Pause Every Afternoon"
    ],
    [
      "Spot and Write Down 3 Positive Emotions Daily",
      "Practice Assertive Communication",
      "Listen to echo Soundscapes for Emotional Balance"
    ],
    [
      "Track Your Mood Patterns on echoBuddy Dashboard",
      "Express Yourself Through Art or Music Weekly",
      "Take a Gratitude Moment to Reset Daily"
    ],
    [
      "Set One Emotional Growth Goal Every Week",
      "Reflect on Your Key Relationships Each Sunday",
      "Join echoBuddy Daily Yoga for Mindfulness"
    ]
  ],

  healthy: [
    [
      "Sustain Your Positive Habits with echoBuddy",
      "Do a Desk Stretch to Refresh Your Body",
      "Reflect Mindfully for 10 Minutes Every Day"
    ],
    [
      "Celebrate One Small Emotional Win Every Day",
      "Listen to echo Soundscapes for Advanced Mindfulness",
      "Practice a Smile Break with Your Team"
    ],
    [
      "Participate in echoBuddy Wellness Activities",
      "Practice Active Listening in Every Interaction",
      "Take a Gratitude Moment to Build Positive Habits"
    ],
    [
      "Deepen Self-Awareness Through Daily Meditation with echo Soundscapes",
      "Build Empathy Actively in Your Team",
      "Design and Follow a Personal Wellbeing Ritual"
    ],
    [
      "Share One Emotional Wellness Tip with Your Team Weekly",
      "Apply a Positive Psychology Practice Each Day",
      "Join echoBuddy Daily Yoga for Mindfulness"
    ]
  ],

  thriving: [
    [
      "Mentor Someone in Emotional Wellbeing Today",
      "Lead a Wellness Challenge at Your Workplace",
      "Explore Advanced Mindfulness with echo Soundscapes"
    ],
    [
      "Build Psychological Safety in Your Team Actively",
      "Practise Compassionate Leadership Every Day",
      "Listen to echo Soundscapes for Deep Mindfulness"
    ],
    [
      "Build a Resilience Toolkit and Share It with Your Team",
      "Champion Mental Health Awareness at Work",
      "Join echoBuddy Daily Yoga for Peak Emotional Health"
    ],
    [
      "Listen to echo Soundscapes Daily",
      "Lead a Gratitude Moment Ritual in Your Next Team Meeting",
      "Practice echoBuddy Guided Breathing Daily"
    ],
    [
      "Contribute Content to the echoBuddy Community",
      "Advocate for Emotional Safety Policies at Work",
      "Pursue an Advanced Emotional Leadership Programme"
    ]
  ]
},


mental: {
  critical: [
    [
      "Attend a Focused echo Soundscape Session Daily",
      "Practice echo Soundscape Meditation Every Night",
      "Do a Guided Breathing Exercise Twice a Day"
    ],
    [
      "Do Cognitive Grounding Exercises Twice a Day",
      "Practice Guided Breathing Exercise Each Morning",
      "Switch Off All Screens for 2 Hours Each Evening"
    ],
    [
      "Follow a Structured Daily Routine for Stability",
      "Listen to echo Soundscapes Every Night",
      "Join echoBuddy Daily Yoga for Calm and Focus"
    ],
    [
      "Limit Social Media Use to 30 Minutes Daily",
      "Practice Guided Breathing Techniques Today",
      "Listen to echo Soundscapes for Mental Calm"
    ],
    [
      "Follow a Sleep Hygiene Protocol — Aim for 7–8 Hours",
      "Use Anti-Anxiety Breathing Techniques Each Morning",
      "Listen to echo Sleep Soundscapes Every Night"
    ]
  ],

  atRisk: [
    [
      "Listen to echo Focus and Calm Soundscapes Daily",
      "Practice a 10-Minute Breathing Meditation Daily",
      "Switch Off All Screens 1 Hour Before Bed"
    ],
    [
      "Identify Your Stress Triggers Using echoBuddy",
      "Build a Wind-Down Routine with echo Soundscapes",
      "Take a Smile Break Every Afternoon"
    ],
    [
      "Play echo Focus Soundscapes While Working",
      "Take a 5-Minute Breathing Break Every Hour",
      "Reframe One Negative Thought Each Day"
    ],
    [
      "Declutter Your Workspace",
      "Write in a Gratitude Journal Every Night",
      "Practice Guided Breathing on echoBuddy"
    ],
    [
      "Practice Single-Tasking to Improve Focus",
      "Do a Desk Stretch for Mental Reset",
      "Join echoBuddy Daily Yoga for Stress Relief"
    ]
  ],

  developing: [
    [
      "Meditate Mindfully for 10 Minutes with echo Soundscapes",
      "Practice Guided Breathing on echoBuddy Daily",
      "Join echoBuddy Daily Yoga Sessions"
    ],
    [
      "Work in Deep Focus Blocks Every Morning",
      "Listen to echo Focus Soundscapes",
      "Attend echoBuddy Daily Yoga for Mindful Monday"
    ],
    [
      "Track Your Mental Energy Levels on echoBuddy Daily",
      "Start Every Morning with a Guided Breathing Routine",
      "Practice Breathwork for 10 Minutes Each Afternoon"
    ],
    [
      "Plan Your Week Ahead to Reduce Decision Fatigue",
      "Listen to echo Soundscapes for Mental Clarity",
      "Take a Smile Break to Refresh Your Focus"
    ],
    [
      "Attend a Focused echo Soundscape Therapy Session Weekly",
      "Set One Mental Growth Goal Every Month",
      "Reflect and Journal Every Week"
    ]
  ],

  healthy: [
    [
      "Set and Pursue a Stretch Goal for Mental Growth",
      "Listen to echo Soundscapes Regularly",
      "Join echoBuddy Daily Yoga for Peak Performance"
    ],
    [
      "Apply Deep Work Techniques in Your Daily Schedule",
      "Reset with echo Soundscapes",
      "Take a Gratitude Moment to Anchor Your Day"
    ],
    [
      "Listen to echo Soundscapes Daily",
      "Practice a Smile Break for Mental Refresh",
      "Do a Desk Stretch to Sustain Focus"
    ],
    [
      "Practice Mindful Leadership Techniques Every Day",
      "Strengthen Strategic Thinking with a Weekly Exercise",
      "Join echoBuddy Daily Yoga for Mindfulness"
    ],
    [
      "Explore echo Binaural Beats Soundscapes for Focus",
      "Conduct a Weekly Mental Energy Audit",
      "Practice Guided Breathing for Peak Mental Performance"
    ]
  ],

  thriving: [
    [
      "Listen to echo Soundscapes for Advanced Mental Performance",
      "Apply a Positive Psychology Framework Every Week",
      "Lead a Wellness Yoga Challenge at Your Workplace"
    ],
    [
      "Lead a Mental Wellness Initiative at Your Workplace",
      "Use Advanced Breathing Techniques Daily",
      "Advocate for a Mental Health Policy at Work"
    ],
    [
      "Mentor a Colleague on Managing Stress Effectively",
      "Study the Neuroscience of Peak Performance",
      "Listen to echo Soundscapes for Deep Focus"
    ],
    [
      "Build a Growth Mindset Culture Within Your Team",
      "Practice Advanced echo Sound Healing Techniques Weekly",
      "Run echoBuddy Mental Fitness Bootcamps for Peers"
    ],
    [
      "Advocate for Workplace Mental Health Days",
      "Tell Your Thriving Mental Wellness Story on echoBuddy",
      "Join echoBuddy Daily Yoga and Lead by Example"
    ]
  ]
},


physical: {
  critical: [
    [
      "Start Gentle Chair Yoga with echoBuddy Daily Yoga Today",
      "Practice 5 Minutes of Breathing Exercises Every Day",
      "Listen to echo Soundscapes for Restorative Calm"
    ],
    [
      "Walk 2,000 Steps Today and Build from There",
      "Drink 8 Glasses of Water Every Day",
      "Do Desk Stretches Every Hour to Keep Moving"
    ],
    [
      "Follow the echoBuddy Engagement Daily",
      "Stretch Gently for 10 Minutes Every Morning",
      "Set a Fixed Bedtime and Sleep for 7–8 Hours"
    ],
    [
      "Plan Nutritious Meals and Cut Processed Food",
      "Step Outside for 5 Minutes of Sunlight Every Day",
      "Listen to echo Soundscapes for a Physical Reset"
    ],
    [
      "Listen to echo Soundscapes Daily",
      "Pair Up with a Physical Wellness Buddy Today",
      "Practice Yoga Nidra with echoBuddy Daily Yoga Each Night"
    ]
  ],

  atRisk: [
    [
      "Walk 5,000 Steps Every Day",
      "Do a Desk Stretch Every Morning",
      "Listen to echo Soundscapes to Wind Down at Night"
    ],
    [
      "Hit 5,000 Steps Today and Track Your Progress",
      "Replace One Processed Meal with Whole Food Daily",
      "Walk for 10 Minutes After Your Lunch Break"
    ],
    [
      "Join echoBuddy Daily Yoga on the Weekend",
      "Take a Guided Breathing Break Before Bed",
      "Stop Drinking Caffeine After 2 PM Daily"
    ],
    [
      "Practice 15 Minutes of Desk Yoga Twice a Week",
      "Add One More Fruit or Vegetable to Every Meal",
      "Take the Stairs Instead of the Lift Every Day"
    ],
    [
      "Follow the echoBuddy Daily",
      "Build a Simple Home Workout Routine This Week",
      "Listen to echo Soundscapes for a Physical Recovery Session"
    ]
  ],

  developing: [
    [
      "Join echoBuddy Daily Yoga Sessions Every Morning",
      "Practice Desk Stretches for Quick Stress Relief",
      "Walk for 15 Minutes After Every Meal"
    ],
    [
      "Hit 7,500 Steps Every Day",
      "Work Out at Home for 20 Minutes 3 Times a Week",
      "Eat Every Meal Mindfully — No Screens at the Table"
    ],
    [
      "Practice a Gratitude Moment Daily",
      "Try One New Physical Activity Every Week",
      "Drink 2.5 Litres of Water Every Day"
    ],
    [
      "Sign Up for an echoBuddy Fitness Challenge This Month",
      "Go to Bed and Wake Up at the Same Time Every Day",
      "Do Desk Stretches to Correct Posture Daily"
    ],
    [
      "Set One Monthly Physical Goal on echoBuddy",
      "Do Bodyweight Strength Training Twice a Week",
      "Join echoBuddy Daily Yoga to Track Your Progress"
    ]
  ],

  healthy: [
    [
      "Follow a Balanced Nutrition Plan Every Day",
      "Hit 8,000 Steps Every Day",
      "Join echoBuddy Daily Yoga Weekend Challenge"
    ],
    [
      "Add Interval Training to Your Weekly Routine",
      "Practice echoBuddy Daily Yoga for Flexibility",
      "Listen to echo Soundscapes for a Pre-Bed Wind-Down"
    ],
    [
      "Try an Outdoor Sport or Group Fitness Class",
      "Strength Train 3 Times Every Week",
      "Eat Seasonal and Locally Sourced Meals"
    ],
    [
      "Share Your Fitness Routine with a Colleague",
      "Practice a Recovery Technique After Every Workout",
      "Do a Smile Break After Your Workout"
    ],
    [
      "Join the echoBuddy Daily Sound Routines",
      "Add Functional Fitness Exercises to Your Routine",
      "Practice Guided Breathing After Every Workout"
    ]
  ],

  thriving: [
    [
      "Train Towards a Wellness Goal Like a 5K or Yoga Cert",
      "Support a Colleague in Their Physical Wellness Journey",
      "Join echoBuddy Daily Yoga to Lead by Example"
    ],
    [
      "Take On an Advanced Athletic Training Programme",
      "Lead a Workplace Step Challenge for Your Team",
      "Mentor a Colleague on Physical Wellbeing"
    ],
    [
      "Create Physical Wellness Content for echoBuddy",
      "Study Sports Nutrition and Performance Techniques",
      "Listen to echo Soundscapes for Recovery"
    ],
    [
      "Advocate for Active Workplace Design in Your Office",
      "Explore a Biohacking Technique for Physical Performance",
      "Lead the echoBuddy Physical Thriving Programme"
    ],
    [
      "Train for a Marathon or Endurance Event",
      "Join echoBuddy Daily Yoga for Advanced Performance",
      "Inspire Your Team with Your Physical Wellness Journey"
    ]
  ]
},

social: {
  critical: [
    [
      "Listen to echo Soundscapes Daily",
      "Start One Meaningful Conversation Every Day",
      "Join echoBuddy Daily Yoga to Connect with Peers"
    ],
    [
      "Reach Out to One Trusted Friend or Colleague Today",
      "Join echoBuddy Daily Yoga Session Today",
      "Listen Actively and Fully in Every Conversation"
    ],
    [
      "Write a Message to Someone You Trust Today",
      "Do a Smile Break to Build Positive Social Energy",
      "Step Outside and Interact with Someone Every Day"
    ],
    [
      "Identify One Safe Person to Talk to Every Week",
      "Access echoBuddy Daily",
      "Do One Small Act of Kindness Every Day"
    ],
    [
      "Listen to echoBuddy Soundscapes Everyday",
      "Schedule a Coffee Chat with a Colleague This Week",
      "Sign Up to Volunteer for a Local Community Initiative"
    ]
  ],

  atRisk: [
    [
      "Listen to echoBuddy Soundscapes Daily",
      "Reach Out to a Trusted Colleague Every Week",
      "Participate in a Team Building Activity This Month"
    ],
    [
      "Invite a Peer for Lunch or Coffee This Week",
      "Attend One Social or Community Event This Month",
      "Practice Assertive Communication in Your Next Conversation"
    ],
    [
      "Listen to echo Soundscapes This Week",
      "Express Appreciation to 3 People This Week",
      "Learn and Apply One Conflict Resolution Technique"
    ],
    [
      "Set Clear Boundaries to Protect Your Social Energy",
      "Reconnect with an Old Friend This Month",
      "Join echoBuddy Daily Yoga to Build Social Connection"
    ],
    [
      "Schedule Regular Check-ins with Your Team",
      "Publicly Celebrate a Colleague's Win This Week",
      "Complete the echoBuddy Wellness Assessment"
    ]
  ],

  developing: [
    [
      "Collaborate Positively on a Workplace Initiative",
      "Sign Up to Volunteer for a Community Programme",
      "Join echoBuddy Daily Yoga to Expand Your Network"
    ],
    [
      "Join a Cross-Functional Project at Work",
      "Complete the echoBuddy Wellness Assessment",
      "Start a Conversation Using a Gratitude-Based Opener"
    ],
    [
      "Create a Weekly Team Ritual Like Shout-outs",
      "Ask Open-Ended Questions in Every Chat",
      "Listen to echo Soundscapes Together with a Peer"
    ],
    [
      "Organise a Team Lunch or Virtual Hangout This Week",
      "Connect with a Mentor or Role Model Every Month",
      "Share Your Ideas Confidently in Your Next Meeting"
    ],
    [
      "Take Part in the echoBuddy Social Impact Challenge",
      "Build One New Positive Connection Every Week",
      "Do a Smile Break Activity with Your Team"
    ]
  ],

  healthy: [
    [
      "Foster Cross-Team Collaboration on a Project",
      "Volunteer for a CSR Initiative This Month",
      "Celebrate Your Team's Wins and Milestones"
    ],
    [
      "Lead a Knowledge-Sharing Session for Your Team",
      "Build a Relationship Outside Your Department",
      "Listen to echo Soundscapes for Team Bonding Sessions"
    ],
    [
      "Organise a Peer Wellness Social Event This Month",
      "Practice Inclusive Communication",
      "Join echoBuddy Daily Yoga with a Colleague"
    ],
    [
      "Nominate a Colleague for a Wellness Recognition Award",
      "Participate in the echoBuddy Social Impact Drive",
      "Take a Gratitude Moment for Your Relationships Daily"
    ],
    [
      "Share Positive Stories in Your Team Channel Weekly",
      "Collaborate on a Social Good Project This Quarter",
      "Do a Smile Break with Your Team Daily"
    ]
  ],

  thriving: [
    [
      "Champion a Wellness Culture at Your Workplace",
      "Build Inclusive Social Networks Within Your Organisation",
      "Mentor Someone in Social Wellbeing Practices"
    ],
    [
      "Lead echoBuddy Social Wellness Campaigns",
      "Advocate for Psychological Safety in Your Team",
      "Host a Cross-Organisational Networking Event"
    ],
    [
      "Build a Social Capital Strategy for Your Team",
      "Launch a Community Wellness Initiative",
      "Join echoBuddy Daily Yoga as a Team Leader"
    ],
    [
      "Inspire Others by Sharing Your Connection Journey",
      "Model Vulnerability and Authentic Leadership Every Day",
      "Take a Gratitude Moment Practice and Teach It to Others"
    ],
    [
      "Co-design an echoBuddy Social Thriving Programme",
      "Establish a Peer Mentoring Network",
      "Advocate for Social Wellbeing Policies at Work"
    ]
  ]
},

financial: {
  critical: [
    [
      "Access echoBuddy Financial SOS Resources Right Now",
      "Build a Basic Emergency Budget Plan Today",
      "Take a Guided Breathing Break to Manage Financial Stress"
    ],
    [
      "List All Your Debts and Minimum Payments Today",
      "Cut Every Non-Essential Expense Starting Now",
      "Listen to echo Soundscapes to Manage Stress"
    ],
    [
      "Apply for Employee Financial Assistance Today",
      "Set Up a Zero-Based Monthly Budget This Week",
      "Join echoBuddy Daily Yoga to Stay Calm Through Crisis"
    ],
    [
      "Research Government or NGO Financial Aid Options",
      "Cancel All Non-Urgent Subscriptions Today",
      "Practice Guided Breathing for Financial Stress Relief"
    ],
    [
      "Build a 7-Day Cash Flow Tracker Starting Today",
      "Identify One Additional Source of Income This Week",
      "Take a Gratitude Moment to Ground Yourself Daily"
    ]
  ],

  atRisk: [
    [
      "Set Up a Monthly Budget Tracker This Week",
      "Start Building a 3-Month Emergency Fund Now",
      "Listen to echo Soundscapes to Ease Financial Anxiety"
    ],
    [
      "Review and Cut All Unnecessary Monthly Subscriptions",
      "Open a Low-Risk Savings Instrument This Month",
      "Take a Breathing Break When Financial Stress Peaks"
    ],
    [
      "Set One Clear Financial Goal for This Quarter",
      "Grow Your Emergency Fund by 10% This Month",
      "Join echoBuddy Daily Yoga to Reduce Stress"
    ],
    [
      "Learn How to Improve Your Credit Score",
      "Automate 10% of Your Salary Into Savings",
      "Do a Gratitude Moment to Maintain a Positive Mindset"
    ],
    [
      "Split Your Budget Into Needs and Wants",
      "Complete the echoBuddy Financial Health Module",
      "Practice Guided Breathing to Stay Calm and Focused"
    ]
  ],

  developing: [
    [
      "Start a Systematic Savings Habit This Month",
      "Track and Cut Unnecessary Spending Every Week",
      "Join echoBuddy Daily Yoga to Stay Disciplined"
    ],
    [
      "Open a Dedicated Goal Savings Account Today",
      "Learn the Basics of Mutual Funds and SIPs",
      "Listen to echo Soundscapes While Reviewing Your Budget"
    ],
    [
      "Explore Tax-Saving Investment Options This Month",
      "Build Towards a 6-Month Emergency Fund",
      "Practice Guided Breathing to Stay Financially Focused"
    ],
    [
      "Review Your Insurance Coverage for Adequacy",
      "Set Up Automated Monthly SIP Investments Today",
      "Take a Gratitude Moment to Celebrate Small Financial Wins"
    ],
    [
      "Research One Passive Income Opportunity This Month",
      "Create a 3-Year Personal Financial Roadmap",
      "Do a Smile Break — You Are Making Progress!"
    ]
  ],

  healthy: [
    [
      "Build an Advanced Wealth Plan with a Professional",
      "Review and Strengthen Your Retirement Planning",
      "Listen to echo Soundscapes for a Clear Mind"
    ],
    [
      "Grow Your Equity and Mutual Fund Portfolio",
      "Review Your Retirement Corpus Target This Quarter",
      "Join echoBuddy Daily Yoga to Build a Healthy Routine"
    ],
    [
      "Diversify Your Investments Across Multiple Asset Classes",
      "Maximise Your Tax-Saving Instruments Like 80C and NPS",
      "Share Your Financial Tips with Peers on echoBuddy"
    ],
    [
      "Draft a Will and Estate Succession Plan This Year",
      "Explore ESG and Impact Investment Options",
      "Take a Gratitude Moment — Your Financial Health Is Strong"
    ],
    [
      "Research Offshore or Global Investment Opportunities",
      "Mentor a Colleague on Personal Financial Planning",
      "Do a Smile Break — You Are Thriving Financially!"
    ]
  ],

  thriving: [
    [
      "Explore Advanced Investment Diversification Strategies",
      "Mentor Someone on Financial Planning",
      "Listen to echo Soundscapes for Peak Mental Performance"
    ],
    [
      "Build a Multi-Generational Wealth Plan This Year",
      "Champion Financial Literacy Initiatives at Your Workplace",
      "Join echoBuddy Daily Yoga to Model Holistic Wellness"
    ],
    [
      "Study Global Market Investment Strategies",
      "Lead echoBuddy Financial Thriving Workshops",
      "Practice Guided Breathing to Stay Grounded in Abundance"
    ],
    [
      "Establish a Family Trust or Foundation",
      "Explore the FIRE Model (Financial Independence Retire Early)",
      "Take a Gratitude Moment for Your Wealth and Health"
    ],
    [
      "Share Your Financial Success Story on echoBuddy",
      "Advocate for Employee Financial Wellness Policies",
      "Do a Smile Break — You Are an Inspiration to Others!"
    ]
  ]
}
};